import gql from 'graphql-tag'

export const TourCategoriesFragment = gql`
	fragment TourCategoriesFragment on TourTopCategory {
		id
        title
        slug
        total
        categories {
            id
            title
            total
        }
	}
`

export const TourCategoriesQuery = gql`
	query tourCategories($where: TourCategoryWhereInput!) {
		tourCategories(where: $where) {
			...TourCategoriesFragment
		}
	}
	${TourCategoriesFragment}
`

export interface ITourCategoriesQueryVariables {
    where: ITourCategoriesQueryWhereInput
}

export interface ITourCategoriesQueryWhereInput {
    language: string
    countryId: number
}

export interface ITourCategoriesQueryData {
    tourCategories?: Array<ITourTopCategory>
}

export interface ITourTopCategory {
    id: number
    title: string
    slug: string
    categories: Array<ITourCategory>
    total: number
}

export interface ITourCategory {
    id: number
    title: string
    total: number
}